import { render, staticRenderFns } from "./HiperlinkComponent.vue?vue&type=template&id=0be224f2&scoped=true"
import script from "./HiperlinkComponent.vue?vue&type=script&lang=js"
export * from "./HiperlinkComponent.vue?vue&type=script&lang=js"
import style0 from "./HiperlinkComponent.vue?vue&type=style&index=0&id=0be224f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be224f2",
  null
  
)

export default component.exports